<section class="h-5/6">
	<div class="py-8 px-4 mx-auto my-auto max-w-screen-xl lg:py-16 lg:px-6 lg:h-full xl:h-full flex flex-col justify-center">
		<div class="mx-auto max-w-screen-sm text-center justify-center">
			<p class="mb-4 text-9xl font-bold text-portals-primary-900 md:text-9xl dark:text-white">500</p>
			<p class="mb-4 text-3xl font-bold text-gray-900 md:text-4xl dark:text-white">Internal Server Error.</p>
			<p class="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">We are already working to solve the problem.</p>
		</div>
	</div>
</section>
